<script setup lang="ts">
import {
  Modal,
  ModalBody,
  ModalHeader,
} from '@wartek-id/belajar-id-components'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
  modelValue: boolean
  title: string
  iframeUrl: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const isOpen = useVModel(props, 'modelValue', emit)

const iframeHeight = '576px'
const iframeWidth = '1024px'
</script>

<template>
  <Modal
    v-slot="{ close }"
    v-model="isOpen"
    class="modal-iframe"
    :width="1080"
  >
    <ModalHeader class="text-base bg-white border-none" @close="close">
      {{ props.title }}
    </ModalHeader>

    <ModalBody class="pt-0 pb-5">
      <div class="iframe-container">
        <iframe
          :src="props.iframeUrl"
          :width="iframeWidth"
          :height="iframeHeight"
          :title="props.title"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </ModalBody>
  </Modal>
</template>

<style scoped>
.iframe-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
}

iframe {
  max-width: 100%;
  border-radius: 8px;
}
</style>
